import { render, staticRenderFns } from "./ProjectListItem.vue?vue&type=template&id=6a01fdf4&scoped=true"
import script from "./ProjectListItem.vue?vue&type=script&lang=js"
export * from "./ProjectListItem.vue?vue&type=script&lang=js"
import style0 from "./ProjectListItem.vue?vue&type=style&index=0&id=6a01fdf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a01fdf4",
  null
  
)

export default component.exports